/**
 * État du compte connecté rangé dans localStorage par le BO Contrôle.
 *
 * Le BO billetterie et le BO Contrôle partagent la session Auth0 : on peut changer
 * de compte sur l'écran de connexion Auth0 sans passer par « Déconnexion ». Sans
 * remise à zéro, le nouveau compte hérite alors de l'impersonate, de la liste
 * courante et des permissions de l'ancien, et sa connexion échoue (#5824).
 */
const SESSION_OWNER_KEY = 'sessionOwner';

const SESSION_STATE_KEYS = [
  SESSION_OWNER_KEY,
  'authUser', 'idUser', 'infoUser', 'dataList', 'dataAllLists',
  'impersonating', 'impersonatedOrganizer', 'impersonatedOrganizerName', 'originalUserEmail',
  'isAdmin', 'canImpersonate', 'impersonateRole', 'isStaff', 'isCanary',
  'isMember', 'memberEmail', 'memberPermissions',
];

/** Efface l'état du compte connecté (le cache Auth0 du SDK n'est pas concerné). */
export function clearSessionState(): void {
  SESSION_STATE_KEYS.forEach(key => localStorage.removeItem(key));
}

/**
 * Rattache l'état stocké au compte Auth0 `owner` (son `sub`). Efface l'état d'un
 * autre compte, ou d'un propriétaire inconnu. Retourne true si l'état a été effacé.
 */
export function bindSessionState(owner: string): boolean {
  if (localStorage.getItem(SESSION_OWNER_KEY) === owner) return false;
  clearSessionState();
  localStorage.setItem(SESSION_OWNER_KEY, owner);
  return true;
}
